document.querySelectorAll('[data-slider="gallery-swiper"]').forEach((el) => {
  const parent = el.closest('.gallery-slider');

  new Swiper(el, {
    slidesPerView: 4,
    spaceBetween: 0,
    watchOverflow: true,
    loop: false,
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 4 },
    },
    navigation: {
      nextEl: parent.querySelector('.swiper-button-next'),
      prevEl: parent.querySelector('.swiper-button-prev'),
    },
  });
});
